module.exports = __webpack_public_path__ + "img/icon-divide_s.8bf82508.svg";